import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Brand from '../Brand/index.js';
import styles from './Wrapper.module.scss.js';

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
    imagePreview = _ref.imagePreview,
    isPaymentLP = _ref.isPaymentLP,
    showBrandName = _ref.showBrandName,
    showLogo = _ref.showLogo,
    showSocialLinks = _ref.showSocialLinks,
    socialLinks = _ref.socialLinks,
    values = _ref.values;
  var coverImage = values === null || values === void 0 ? void 0 : values.cover_preview;
  var renderCover = function renderCover() {
    return /*#__PURE__*/React.createElement("div", {
      className: cx(styles.coverPhoto),
      style: {
        backgroundImage: "url('" + coverImage + "')"
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.wrapper, 'page')
  }, imagePreview && renderCover(), /*#__PURE__*/React.createElement(Brand, {
    showBrandName: showBrandName,
    showLogo: showLogo,
    showSocialLinks: showSocialLinks,
    socialLinks: socialLinks,
    values: values,
    isPaymentLP: isPaymentLP,
    imagePreview: imagePreview
  }), /*#__PURE__*/React.createElement("div", null, children));
};
Wrapper.propTypes = {
  children: PropTypes.node,
  imagePreview: PropTypes.string,
  isPaymentLP: PropTypes.bool,
  showBrandName: PropTypes.bool,
  showLogo: PropTypes.bool,
  showSocialLinks: PropTypes.bool,
  socialLinks: PropTypes.object,
  values: PropTypes.object
};
var Wrapper$1 = /*#__PURE__*/React.memo(Wrapper);

export { Wrapper$1 as default };
//# sourceMappingURL=index.js.map
